<template>
<div v-if="isShow && template">
    <header>
        自己紹介テンプレート
        <div class="h-left">
            <a @click="$emit('close')"><img src="~@/assets/images/icon02.svg" /></a>
        </div>
    </header>
    <div id="wrap" style="overflow-x:hidden">
        <div class="template" v-for="(item, index) in template[TEMPLATE_TYPE_USER_STATUS]" :key="index">
            <p style="word-wrap: break-word">{{item}}</p>
            <div class="btn1">
                <a @click="setValue(item)">このテンプレートを使う</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import CONSTANTS from "@/constants";
export default {
    props: {
        isShow: Boolean,
    },
    emits: ['close'],
    data: () => ({
        value: null,
        TEMPLATE_TYPE_USER_STATUS: CONSTANTS.TEMPLATE_TYPE_USER_STATUS,
        template: null
    }),
    computed: {
        ...mapGetters(["metadata", "profileTemplate", "defaultToken"]),
    },
    mounted() {
        if (!this.profileTemplate) {
            this.getProfileTemplate({
                token: this.defaultToken
            }).then(data => {
                this.template = data
            });
        } else {
            this.template = this.profileTemplate;
        }
    },
    methods: {
        ...mapActions({
            getProfileTemplate: "profile/getProfileTemplate"
        }),
        setValue(value) {
            this.value = value;
            this.$emit("getValue", value);
        },
    },
};
</script>
